import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Radio, Row } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { spacing } from "../../../../../../styles/spacing.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateIsEmbeddingOnlyExternalResources({ options }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.IsEmbeddingOnlyExternalResources,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.IsEmbeddingOnlyExternalResources, t),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || prev.isEmbeddingOnlyExternalResources !== next.isEmbeddingOnlyExternalResources,
            rules: [
                {
                    required: true,
                    message: t("Please define if only external resources are used but no cookies.")
                }
            ],
            required: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.IsEmbeddingOnlyExternalResources,
                    disableStrategies: getDisableStrategies(),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Radio.Group, {
                            defaultValue: Boolean(extended[ServiceTemplateField.IsEmbeddingOnlyExternalResources]),
                            options: options,
                            optionType: "button",
                            buttonStyle: "solid",
                            disabled: true
                        })
                    }),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        style: {
                            display: "flex",
                            alignItems: "baseline"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsx(Form.Item, {
                                    name: ServiceTemplateField.IsEmbeddingOnlyExternalResources,
                                    noStyle: true,
                                    children: /*#__PURE__*/ _jsx(Radio.Group, {
                                        options: options,
                                        optionType: "button",
                                        buttonStyle: "solid"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                style: {
                                    paddingLeft: spacing.layout.content.padding
                                },
                                children: t("This service does not set any technical cookies on the client of the visitor, but e.g. integrates a script.")
                            })
                        ]
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateIsEmbeddingOnlyExternalResources };
